import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatMinutes',
    standalone: false
})
export class formatMinutesPipe implements PipeTransform {
   transform(seconds: number): string {
      return formatMinutes(seconds);
   }
}

export function formatMinutes(seconds: number): string {
   // should return format 00:00 hh:mm. do not return seconds
   const hours = Math.floor(seconds / 3600);
   const minutes = Math.floor((seconds % 3600) / 60);
   const remainingSeconds = seconds % 60;

   return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
